import React from "react";
import {GET_CURRENT_CONTEST_TAG} from "../../../../../AdminPart/GraphQL/queries/OnlyHereQueries";
import {useQuery} from "@apollo/client";

function QueryCurrentContestTag (props) {
    const { loading, error, data} = useQuery(GET_CURRENT_CONTEST_TAG, {variables : {ContestName : props.ContestName}});
    if (loading) return 'loading...';
    if (error) return `loading error! ${error.message}`;const ContestTag = data.GetCurrentContestTag.Info;
    // console.log('GetCurrentContestTag',data);
    return (
        <div className="StandartPage">
            <iframe
                src={"https://my.fxbitcoin.org/iframe/trading-accounts/by-tag/"+ ContestTag}
                name="FXBitcoinTrader" title='FXBitcoinTrader' className="autoHeight-iframe" frameBorder="0" width="100%" height="800"/>
        </div>

    )}
export default QueryCurrentContestTag